/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type UserPopoverContainer_settings = {
    readonly " $fragmentRefs": FragmentRefs<"UserPopoverOverviewContainer_settings">;
    readonly " $refType": "UserPopoverContainer_settings";
};
export type UserPopoverContainer_settings$data = UserPopoverContainer_settings;
export type UserPopoverContainer_settings$key = {
    readonly " $data"?: UserPopoverContainer_settings$data;
    readonly " $fragmentRefs": FragmentRefs<"UserPopoverContainer_settings">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "UserPopoverContainer_settings",
    "selections": [
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "UserPopoverOverviewContainer_settings"
        }
    ],
    "type": "Settings",
    "abstractKey": null
} as any);
(node as any).hash = '8c648064efb3ffa619123cd87a68c129';
export default node;
